if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');

        // custom variants jq codes

          $('.itg_product .itg_variant_label .form__label').on("click", function(){
          $(this).toggleClass('actives_label')
          $(this).parents('.itg_variant_label').find('.itg_variant_show').slideToggle();
          });


          $(document).on("click",".itg_var_flex label",function() {
    
       $(this).closest('.multiple_productlist').find('label').removeClass('active');
       var thsadd = $(this).addClass('active');
       var mainprice = parseFloat($(document).find('#addonsprice').attr('data-main-price').replace('$',''));
        var total = 0;
        $('label.radioval.active').each(function(){
           total += parseFloat($(this).attr('data-variant_price'));
        });
        var finalprice = parseFloat(total) + mainprice;
        var finalprice = finalprice.toFixed(2);
        $(document).find('#addonsprice').text('$'+finalprice);
  });
   
  $(document).on("click","#custom_addtocart",function() {

       var varid = $(document).find('.product-variant-id').val();
       var varqty = $(document).find('.itg_quantity_addcart .quantity__input').val();
        $(this).find('.custom_loader').removeClass('hidden');
        $(this).find('.custom_loader').removeClass('hidden');
         $(this).css("background-color", "#320b0db8");
         $(this).find('span').hide();
        $(this).find('.custom_loader svg circle').css("stroke", "#fff");

         
       
        var available_ids = [];
        $('label.radioval.active').each(function(){
        	    var thisQty = 1;
              	var xVarID = $(this).attr('for');
              	var toPushItem = xVarID+'-'+thisQty;
              	available_ids.push(toPushItem);
            
        }).promise().done( function(){ 
          
        });
        var arrylength = available_ids.length;
        if(arrylength == 0){

           var dataarr = {
              "id": varid,
              "quantity": varqty
            }
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: dataarr,
              dataType: 'json',
              success: function() { 
                window.location.href = '/cart'; 
              }
            });
          
        }else{
          
          for (var i = 0; i < available_ids.length; i++) {
            (function(i){
                setTimeout(function(){
                    var formContents = available_ids[i].split('-');
                    var params = {
                      type: 'POST',
                      url: '/cart/add.js',
                      data: 'quantity='+formContents[1]+'&id='+formContents[0],
                      dataType: 'json',
                      success: function(line_item) { 
                          var iteration_length = i+1;
                          if( iteration_length == available_ids.length ){ 
                              var dataarr = {
                                "id": varid,
                                "quantity": varqty
                              }
                              jQuery.ajax({
                                type: 'POST',
                                url: '/cart/add.js',
                                data: dataarr,
                                dataType: 'json',
                                success: function() { 
                                  window.location.href = '/cart'; 
                                }
                              });
                          }
                      },error: function() {
                          console.log("fail");
                      }
                  };
                  $.ajax(params); 
                }, 1000 * i);
            }(i));
          }
          
        }
  });
  

        // custom variants jq end

        
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
